import { Avatar, IconButton, List, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

const attributeData = [
    {
        name_th: "ประเภทสถานที่",
        attribute: "place_type_name"
    },
    {
        name_th: "วันที่เริ่มต้นการสำรวจ",
        attribute: "start_date",
    },
    {
        name_th: "วันที่เสร็จสิ้นการสำรวจ",
        attribute: "end_date",
    },
    {
        name_th: "จำนวนภาชนะที่สำรวจ",
        attribute: "inspected_container_count",
        unit_th: "ชิ้น"
    },
    {
        name_th: "จำนวนภาชนะที่พบ",
        attribute: "infested_container_count",
        unit_th: "ชิ้น"
    },
    {
        name_th: "จำนวนบ้าน/อาคารที่สำรวจ",
        attribute: "inspected_building_count",
        unit_th: "หลัง/อาคาร"
    },
    {
        name_th: "จำนวนบ้าน/อาคารที่พบ",
        attribute: "infested_building_count",
        unit_th: "หลัง/อาคาร"
    },
    {
        name_th: "จำนวนบ้าน/อาคารที่ไม่มีภาชนะ",
        attribute: "building_without_container",
        unit_th: "หลัง/อาคาร"
    }
]

const outdoor = [
    {
        name_th: "ลำดับที่ 1",
        attribute: "outdoor_container_rank1_name",
        percent: "outdoor_container_rank1_percentage"
    },
    {
        name_th: "ลำดับที่ 2",
        attribute: "outdoor_container_rank2_name",
        percent: "outdoor_container_rank2_percentage"
    },
    {
        name_th: "ลำดับที่ 3",
        attribute: "outdoor_container_rank3_name",
        percent: "outdoor_container_rank3_percentage"
    }
]

const indoor = [
    {
        name_th: "ลำดับที่ 1",
        attribute: "indoor_container_rank1_name",
        percent: "indoor_container_rank1_percentage"
    },
    {
        name_th: "ลำดับที่ 2",
        attribute: "indoor_container_rank2_name",
        percent: "indoor_container_rank2_percentage"
    },
    {
        name_th: "ลำดับที่ 3",
        attribute: "indoor_container_rank3_name",
        percent: "indoor_container_rank3_percentage"
    }
]

function IndexContent(props) {
    const { data } = props;
    const [dataShow, setDataShow] = useState({});
    const [dataList, setDataList] = useState([]);

    useEffect(() => {
        // console.log(data);
        if (data !== undefined) {
            if (data.features !== undefined) {
                if (data.features.length === 1) {
                    setDataShow(data.features[0].values_.attributes);
                } else {
                    setDataList(data.features);
                }
            } else {
                setDataShow(data.attributes);
            }
        }
    }, [data]);

    return (
        <>
            {
                Object.keys(dataShow).length !== 0 ?
                    <Grid container spacing={0}>
                        <Grid xs={dataList.length > 1 ? 10 : 12} sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <Typography variant="h5" className="mb-2 font-primary" sx={{
                                padding: 2,
                                paddingBottom: 0,
                                color: 'white'
                            }}>
                                {
                                    `${dataShow.place_name}`
                                }
                            </Typography>
                        </Grid>
                        <Grid xs={dataList.length > 1 ? 2 : 0} sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <IconButton
                                sx={{
                                    color: 'white',
                                    marginTop: '13px'
                                }}
                                onClick={(event) => {
                                    setDataShow({});
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid xs={12} sx={{
                            backgroundColor: 'rgb(62, 152, 211)',
                            marginBottom: 2
                        }}>
                            <Typography variant="h6" className="mb-2 font-primary" sx={{
                                fontSize: 16,
                                fontWeight: 'normal',
                                paddingLeft: 2,
                                paddingRight: 2,
                                color: 'white'
                            }}>
                                {
                                    `ต.${dataShow.tambon_name} อ.${dataShow.amphur_name} จ.${dataShow.province_name}`
                                }
                            </Typography>
                        </Grid>
                        <Grid xs={4} sx={{
                            borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
                        }}>
                            
                            <Typography variant="subtitle1" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center'
                            }}>
                                {
                                    `HI`
                                }
                            </Typography>
                            <Typography variant="h6" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center',
                                fontWeight: 'normal'
                            }}>
                                {dataShow.hi}
                            </Typography>
                        </Grid>
                        <Grid xs={4} sx={{
                            borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
                        }}>
                            
                            <Typography variant="subtitle1" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center'
                            }}>
                                {
                                    `CI`
                                }
                            </Typography>
                            <Typography variant="h6" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center',
                                fontWeight: 'normal'
                            }}>
                                {dataShow.ci}
                            </Typography>
                        </Grid>
                        <Grid xs={4} sx={{
                            borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
                        }}>
                            
                            <Typography variant="subtitle1" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center'
                            }}>
                                {
                                    `BI`
                                }
                            </Typography>
                            <Typography variant="h6" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center',
                                fontWeight: 'normal'
                            }}>
                                {dataShow.bi}
                            </Typography>
                        </Grid>
                        {
                            attributeData.map((attribute, index) => {
                                let type = 'date';
                                if (attribute.attribute === "place_type_name") {
                                    type = "text";
                                }
                                if (attribute.unit_th !== undefined) {
                                    return (
                                        <React.Fragment key={index}>
                                            <Grid xs={7} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    paddingLeft: 2
                                                }}>
                                                    {attribute.name_th}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={2} sx={{
                                                paddingRight: 2,
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    textAlign: 'right'
                                                }}>
                                                    {dataShow[attribute.attribute].toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={3} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" >
                                                    {attribute.unit_th}
                                                </Typography>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                } else {
                                    return (
                                        <React.Fragment key={index}>
                                            <Grid xs={6} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    paddingLeft: 2
                                                }}>
                                                    {attribute.name_th}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={6} sx={{
                                                paddingRight: 2,
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    textAlign: 'right'
                                                }}>
                                                    {
                                                        type === 'date' ? 
                                                        dayjs(dataShow[attribute.attribute]).format("DD MMMM BBBB") : dataShow[attribute.attribute]
                                                    }
                                                </Typography>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                }
                            })
                        }
                        <Grid xs={12} sx={{
                            paddingLeft: 2,
                            paddingRight: 2,
                            paddingTop: 1,
                            paddingBottom: 1
                        }}>
                            <Typography className="font-primary" >ภาชนะที่พบลูกน้ำยุงลาย 3 อันดับแรก</Typography>
                        </Grid>
                        <Grid xs={12} sx={{
                            paddingLeft: 2,
                            paddingRight: 2,
                            paddingTop: 1,
                            paddingBottom: 2
                        }}>
                            <Typography className="font-primary" >ภายนอกอาคาร</Typography>
                        </Grid>
                        {
                            outdoor.map((attribute, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Grid xs={3} sx={{
                                            paddingLeft: 2,
                                            paddingBottom: 2
                                        }}>
                                            <Typography className="font-primary" >{attribute.name_th}</Typography>
                                        </Grid>
                                        <Grid xs={6} sx={{
                                            textAlign: 'right'
                                        }}>
                                            <Typography className="font-primary" >{dataShow[attribute.attribute] !== "null" ? dataShow[attribute.attribute] : '-'}</Typography>
                                        </Grid>
                                        <Grid xs={3} sx={{
                                            textAlign: 'right',
                                            paddingLeft: 1,
                                            paddingRight: 2
                                        }}>
                                            <Typography className="font-primary" >({dataShow[attribute.percent]}%)</Typography>
                                        </Grid>
                                    </React.Fragment>
                                )
                            })
                        }
                        <Grid xs={12} sx={{
                            paddingLeft: 2,
                            paddingRight: 2,
                            paddingBottom: 1
                        }}>
                            <Typography className="font-primary" >ภายในอาคาร</Typography>
                        </Grid>
                        {
                            indoor.map((attribute, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Grid xs={3} sx={{
                                            paddingLeft: 2,
                                            paddingBottom: 2
                                        }}>
                                            <Typography className="font-primary" >{attribute.name_th}</Typography>
                                        </Grid>
                                        <Grid xs={6} sx={{
                                            textAlign: 'right'
                                        }}>
                                            <Typography className="font-primary" >{dataShow[attribute.attribute] !== "null" ? dataShow[attribute.attribute] : '-'}</Typography>
                                        </Grid>
                                        <Grid xs={3} sx={{
                                            textAlign: 'right',
                                            paddingLeft: 1,
                                            paddingRight: 2
                                        }}>
                                            <Typography className="font-primary" >({dataShow[attribute.percent]}%)</Typography>
                                        </Grid>
                                    </React.Fragment>
                                )
                            })
                        }
                    </Grid> :
                    <List sx={{ width: '100%' }}>
                        {
                            dataList.map((data, index) => {
                                // console.log(data.values_.attributes);
                                return (
                                    <ListItemButton
                                        key={index}
                                        onClick={(event) => {
                                            setDataShow(data.values_.attributes)
                                        }}
                                        // disableGutters
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                src={`/images/markers/${data.values_.attributes.imageSrc}`}
                                            >
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            sx={(theme) => ({
                                                width: 250,
                                                '& .MuiListItemText-primary': {
                                                    overflow: 'hidden'
                                                },
                                                '& .MuiListItemText-secondary': {
                                                    fontSize: 12,
                                                    color: '#000000DE',
                                                }
                                            })}
                                            primary={`${data.values_.attributes.place_name}`}
                                            secondary={`ต. ${data.values_.attributes.tambon_name} อ.${data.values_.attributes.amphur_name} จ.${data.values_.attributes.province_name}`}
                                        />
                                        <ListItemText
                                            sx={(theme) => ({
                                                textAlign: 'center',
                                                '& .MuiListItemText-secondary': {
                                                    fontSize: 18,
                                                    color: '#000000DE'
                                                }
                                            })}
                                            primary={data.values_.attributes.place_type_id === 1 ? "HI" : "CI"}
                                            secondary={data.values_.attributes.place_type_id === 1 ? data.values_.attributes.hi : data.values_.attributes.ci}
                                        />
                                    </ListItemButton>
                                )
                            })
                        }
                    </List>
            }
        </>
    )
}

export default IndexContent
